// Generated by ReScript, PLEASE EDIT WITH CARE

import * as ErrorUtils$Catalyst from "../../../../../../../node_modules/@porterin/catalyst/src/utils/ErrorUtils.bs.js";

function fromString(order_type) {
  switch (order_type) {
    case "ABRTG" :
        return /* ABRTG */1;
    case "Completed" :
        return /* Completed */2;
    case "FRAUD" :
        return /* Fraud */3;
    case "MISSED" :
        return /* Missed */0;
    case "Not_Eligible" :
        return /* NotEligible */4;
    default:
      return ErrorUtils$Catalyst.raiseError("CampaignOrderType.res", "Invalid campaign order type", order_type);
  }
}

export {
  fromString ,
  
}
/* No side effect */
